<mat-card class="can-card mat-elevation-z15">
  <mat-card-content>

    <markdown [src]="'assets/i18n/appeal/' + translate.lang + '.md'"></markdown>

  </mat-card-content>
</mat-card>
